export default __webpack_public_path__ + "static/media/win.69e4619a.png";